import React from 'react';
import { Button } from '@cb/apricot-react';
import './StatsBar.scss';

interface StatsCardProps {
  id: string;
  content: string | number;
  footer: string;
  active?: boolean;
  onClick?: () => void;
}

export const StatsCard: React.FC<StatsCardProps> = ({ id, content, footer, active, onClick }) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (onClick && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <Button
      className={'tdtk-stats-card mb-0' + (active ? ' active' : '')}
      id={id}
      data-testid={`test-${id}`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={onClick ? 0 : -1}
      role='button'
      aria-label={`${footer}: ${content} student${content === 1 ? '' : 's'}`}
      aria-pressed={onClick ? active : undefined}
    >
      <div className='tdtk-stats-card-content'>{content}</div>
      <div className='tdtk-stats-card-footer'>{footer}</div>
    </Button>
  );
};

export default StatsCard;
